<template>
  <div>
    <!-- 取大險種 -->
    <div class="form-group row">
      <label class="col-2 text-right">取大險種</label>
      <div class="col-10 d-inline-grid">
        <input
          type="text"
          class="form-control form-control-inline show-input w-200"
          :class="{ disabled: true }"
        />
      </div>
    </div>

    <!-- 取大期間 -->
    <div class="form-group row">
      <label class="col-2 text-right">取大期間</label>
      <div class="col-10 d-inline-grid">
        <!-- 取大期間-1 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-1"
            v-model="form.max_period"
            value="1"
          />
          <label class="hide-label" for="getMax-1"></label>
          <span class="lh-40 ml-50">終身</span>
        </div>
        <!-- 取大期間-2 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-2"
            v-model="form.max_period"
            value="2"
          />
          <label class="hide-label" for="getMax-2"></label>
          <span class="lh-40 ml-50">繳費期間</span>
        </div>
        <!-- 取大期間-3 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-3"
            v-model="form.max_period"
            value="3"
          />
          <label class="hide-label" for="getMax-3"></label>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80 ml-50"
            :class="{ 'is-invalid': validate.isYearAfterStartErr }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="3"
            v-model.number="form.year_after_start"
          />
          <span class="lh-40">年後開始</span>
        </div>
        <!-- 取大期間-4 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-4"
            v-model="form.max_period"
            value="4"
          />
          <label class="hide-label" for="getMax-4"></label>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80 ml-50"
            :class="{ 'is-invalid': validate.isMaxStartErr }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="3"
            v-model.number="form.max_start"
          />
          <select
            class="form-control form-control-inline form-wide w-100"
            v-model="form.max_start_unit"
          >
            <option
              v-for="item in pageControl.coveragePeriodUnits"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
          <span class="lh-40">到</span>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80"
            :class="{ 'is-invalid': validate.isMaxEndErr }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="3"
            v-model.number="form.max_end"
          />
          <select
            class="form-control form-control-inline form-wide w-100"
            v-model="form.max_end_unit"
          >
            <option
              v-for="item in pageControl.coveragePeriodUnits"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- 取大項目 -->
    <div class="form-group row">
      <label class="col-2 text-right">取大項目</label>
      <div class="col-10 d-inline-grid">
        <!-- 取大項目-1 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="getForm8Value"
            value="1"
            v-model="form.max_item"
          />
          <label class="hide-label" for="getForm8Value"></label>
          <span class="lh-40 ml-50">讀取FORM8的值</span>
          <button
            type="button"
            class="btn btn-default btn-sm"
            :disabled="disableForm8"
            @click="goMaintainForm8()"
          >
            FORM8維護
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddGetMaxFormulaComponent",
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    disableForm8() {
      return this.form.max_item.length === 0;
    },
  },
  methods: {
    goMaintainForm8() {
      let recordAry = [];
      let recordDetail = {
        //編輯模式
        isEditMode: this.form.isEditMode,
        //取大設定
        getMaxId: this.form.getMaxId,
        //取大期間
        max_period: this.form.max_period,
        year_after_start: this.form.year_after_start,
        max_start: this.form.max_start,
        max_start_unit: this.form.max_start_unit,
        max_end: this.form.max_end,
        max_end_unit: this.form.max_end_unit,
        //取大項目
        max_item: this.form.max_item,
      };
      recordAry.push(recordDetail);
      this.$store.dispatch("setRouterPara", {
        pathName: "filterResult",
        setData: recordAry,
      });
      this.$router.push({
        name: "MaintainForm8",
        params: { pageName: this.pageControl.pageName },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.lh-40 {
  line-height: 40px;
}
.w-80 {
  width: 80px !important;
}
.w-100 {
  width: 100px !important;
}
.mb-15 {
  margin-bottom: 15px;
}
.ml-50 {
  margin-left: 50px !important;
}
.show-input {
  opacity: unset;
  position: unset;
}
.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}
.d-inline-grid {
  display: inline-grid;
}
.hide-label {
  height: 0;
}
.disabled {
  pointer-events: none;
  opacity: 0.8;
  cursor: not-allowed;
  border-color: transparent;
  color: #989ca2;
  background: #f5f5f5;
  box-shadow: inset 0 -1px 0 0 #e2e2e2;
}
</style>
